<ng-container *ngIf="data?.length; else emptyTable">
  <div class="data-block" [class.gtin-mode]="gtinMode && ['EWAYBILL', 'TRANSIT'].includes(documentType)" [class.other-doc]="!['EWAYBILL', 'TRANSIT'].includes(documentType) && env.project !== 'BM'">
    <p-table
      [value]="data"
      [scrollable]="true"
      scrollHeight="flex"
      selectionMode="single"
      [class.change-size]="env.project === 'BM'"
      (onRowSelect)="onRowSelect($event)">
        <ng-template pTemplate="header">
            <tr>
              <th>GTIN</th>
              <th i18n>Наименование</th>
              <th i18n>Код ТНВЭД</th>
              <th i18n *ngIf="env.project !== 'BM'">Код по таможенному классификатору</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item" class="single-row">
              <span>
                <td>{{ item.gtin }}</td>
                <td>{{ item.name }}</td>
                <td [class.empty-item]="!item.tnvedCode">{{ item.tnvedCode || "-" }}</td>
                <td class="tac" *ngIf="env.project !== 'BM'">{{ item.extraCustomsCode || "-" }}</td>
              </span>
              <span class="traceable-row" *ngIf="selectRow?.gtin === item.gtin">
                <td></td>
                <td class="traceable-label">
                  <span>{{ handleCodes(item.tnvedCode, item?.extraCustomsCode) ? "Прослеживаемый" : "Непрослеживаемый" }} товар</span>
                  <span [class.error-msg]="isError">Код по таможенному классификатору:</span>
                  <!-- {{ find(item.tnvedCode) }} -->
                </td>
                <td class="editable-tace-block tac" [class.no-editable-btn-view]="!item.extraCustomsCode">
                  <ng-container *ngIf="!findCustomCodes(item.tnvedCode)?.length">
                    <app-number
                      [isDisabled]="!editable"
                      [value]="customCode"
                      (valueChange)="editInputComplete($event)"
                      [maxLength]="4">
                    </app-number>
                    <img
                      *ngIf="item.extraCustomsCode"
                      src="{{ editable ? 'static/icons/NoEdit.svg' : 'static/icons/Edit.svg' }}"
                      (click)="unblockEditable()"
                      alt=""/>
                  </ng-container>
                  <ng-container *ngIf="findCustomCodes(item.tnvedCode)?.length">
                    <p-dropdown
                      [editable]="true"
                      [options]="item.customCodesSets"
                      [style]="{'width':'100%'}"
                      [(ngModel)]="customCode"
											[maxlength]="4"
                      (onChange)="changeDropdownValue($event)"
                      optionLabel="name"
                    ></p-dropdown>
                  </ng-container>
                </td>
              </span>
            </tr>
        </ng-template>
      <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between">
            <span i18n *ngIf="data?.length > 1">Уточните текст поиска.</span>
          </div>
          <button *ngIf="selectRow?.gtin" type="submit" appSkin="action no-shadow bold bordered" (click)="selectCurrentRow()">Далее</button>
      </ng-template>
    </p-table>
  </div>
</ng-container>
<ng-template #emptyTable>
  <div class="empty-table" [class.gtin-mode]="['EWAYBILL', 'TRANSIT'].includes(documentType) || tabMode">
    <span>
      <ng-container *ngIf="!notFound; else notFoundData">
        <ng-container *ngIf="!gtinMode" i18n>Для поиска введите GTIN или наименование</ng-container>
        <ng-container *ngIf="gtinMode && documentType === 'EWAYBILL'" i18n>Для добавления введите GTIN (о.ц.) и наименование</ng-container>
      </ng-container>
      <ng-template #notFoundData i18n>
        Данные по заданному фильтру не найдены
      </ng-template>
    </span>
  </div>
</ng-template>
